// Angular and Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Shared
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { LanguageDialogModule } from '../shared/components/language/language.dialog.module';
import { SharedModule } from '../shared/shared.module';

// Primeng modules
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/tree';
import { TagModule } from 'primeng/tag';

// Components
import { DevicesThListComponent } from './devices-th-list.component';
import { ManageThGroupsDialogComponent } from './manage-groups-dialog/manage-groups.dialog.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
    declarations: [
        DevicesThListComponent,
        ManageThGroupsDialogComponent,
    ],
    imports: [
        BlockableDivModule,
        CheckboxModule,
        CommonModule,
        FormsModule,
        LanguageDialogModule,
        ProgressSpinnerModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        TooltipModule,
        TranslateModule,
        TreeModule,
        TreeTableModule,
        TagModule,
    ],
    exports: [
        DevicesThListComponent,
        ManageThGroupsDialogComponent,
    ]
})
export class DevicesThModule { }
